import { apiInstances } from '../../../../libs';

const { get } = apiInstances.routesInstance;

export default async function getActiveRoute({
  idClouder,
  routeType = 'EXPRESS',
}) {
  return get(`/clouders/${idClouder}/route/active?route_type=${routeType}`);
}
